module.exports = __webpack_public_path__ + "static/face_02-066e25ff1cf55b52dfaa8f69eda8459e.jpg";